export const E_VALUE_ATTRIBUTE = 'e_value';
export const QUERY_COVER_ATTRIBUTE = 'query_cover';
export const HIT_LENGTH_ATTRIBUTE = 'hit_length';
export const PERCENT_IDENTITY_ATTRIBUTE = 'percent_identity';
export const BIT_SCORE_ATTRIBUTE = 'bit_score';

export const BENCHLING_BLAST_MENU_TITLE = 'Run Benchling BLAST';
export const NCBI_BLAST_MENU_TITLE = 'Submit to NCBI BLAST';
